import { create } from 'zustand';

import type { Project } from '@/type';

export default create(() => {
  const projectList = [] as Project[];

  return {
    projectList,
  };
});
